import { Link } from 'react-router-dom';
import { SITE } from '../../config/site';
import { SEO_PAGES } from '../../config/seo';
import { Breadcrumbs } from '../../components/ui/Breadcrumbs';
import { Seo } from '../../components/seo';
import { buildBreadcrumbJsonLd } from '../../seo/buildBreadcrumbJsonLd';
import { buildLocalBusinessJsonLd } from '../../seo/buildLocalBusinessJsonLd';
import styles from './RetailStorePage.module.css';

const MAP_WIDGET_URL = 'https://yandex.ru/map-widget/v1/?z=12&ol=biz&oid=117591841671';

export function RetailStorePage() {
  const seo = SEO_PAGES.retailStore;

  return (
    <div className={`container ${styles.page}`}>
      <Seo
        title={seo.title}
        description={seo.description}
        path={seo.path}
        jsonLd={[
          buildLocalBusinessJsonLd(),
          buildBreadcrumbJsonLd([
            { label: 'Главная', to: '/' },
            { label: 'Розничный магазин', to: '/retail-store' },
          ]),
        ]}
      />

      <Breadcrumbs
        items={[
          { label: 'Главная', to: '/' },
          { label: 'Розничный магазин' },
        ]}
      />

      <h1 className={styles.title}>Розничный магазин</h1>

      <div className={styles.body}>
        <div className={styles.content}>
          <p>
            Это витрина розничного магазина {SITE.name}: все товары в наличии, цены актуальные.
            Регулярно обновляем остатки, но если чего-то не нашлось напишите нам в мессенджер MAX или позвоните по телефону {' '}
            <a href={`tel:${SITE.phone.replace(/\D/g, '')}`}>{SITE.phone}</a>.
          </p>
          <p>
            Доставку по {SITE.city}у можно{' '}
            оформить в мессенджере MAX. Стоимость — по тарифам
            Яндекс Go.
          </p>
          <p>
            Загляните к нам в магазин:{' '}
            <a href={SITE.mapsUrl} target="_blank" rel="noopener noreferrer">
              {SITE.address}
            </a>
            <br />
            Мы работаем {SITE.hours.toLowerCase()}.
          </p>

          <Link to="/catalog" className={styles.catalogLink}>
            Перейти в каталог
          </Link>
        </div>

        <div className={styles.mapWrap}>
          <iframe
            src={MAP_WIDGET_URL}
            title={`Карта магазина ${SITE.name}`}
            className={styles.map}
            loading="lazy"
            allowFullScreen
          />
        </div>
      </div>
    </div>
  );
}
